import { createContext, useContext, useState } from "react";

const LoaderContext = createContext();

export function LoaderProvider({ children }) {
    const [loadingCount, setLoadingCount] = useState(0);

    const showLoader = () => setLoadingCount(c => c + 1);
    const hideLoader = () => setLoadingCount(c => Math.max(c - 1, 0));

    return (
        <LoaderContext.Provider
            value={{
                loading: loadingCount > 0,
                showLoader,
                hideLoader
            }}
        >
            {children}
        </LoaderContext.Provider>
    );
}

export const useLoader = () => useContext(LoaderContext);
